<template>
  <b-card>
    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      <div class="alert-body">
        {{ errorText }}
      </div>
    </b-alert>

    <b-form
      class="mb-2"
      @submit.prevent="search"
    >
      <b-row>
        <b-col
          md="6"
          lg="4"
        >
          <b-form-group
            label="Что ищем"
            description="Id платежа ЮKassa, номер заказа, номер записи или ФИО / e-mail"
          >
            <b-form-input
              v-model="filters.q"
              placeholder="Например, 2f0a1b4c-… или Иванов"
              autofocus
            />
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          lg="2"
        >
          <b-form-group label="Тип">
            <b-form-select
              v-model="filters.type"
              :options="typeOptions"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          lg="2"
        >
          <b-form-group label="Статус">
            <b-form-select
              v-model="filters.status"
              :options="statusOptions"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="6"
          lg="2"
        >
          <b-form-group label="С даты">
            <b-form-input
              v-model="filters.from"
              type="date"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="6"
          lg="2"
        >
          <b-form-group label="По дату">
            <b-form-input
              v-model="filters.to"
              type="date"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-button
        type="submit"
        variant="primary"
        class="mr-1"
      >
        Найти
      </b-button>
      <b-button
        variant="outline-secondary"
        @click="reset"
      >
        Сбросить
      </b-button>
    </b-form>

    <payments-table
      :rows="rows"
      :count="count"
      :page="page"
      :per-page="perPage"
      :loading="loading"
      @page="changePage"
    />
  </b-card>
</template>

<script>
import {
  BAlert, BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BFormSelect, BRow,
} from 'bootstrap-vue'
import moment from 'moment'
import paymentAdminApi from '@/services/payment-admin-api.service'
import PaymentsTable from './components/PaymentsTable.vue'
import { TYPE_LABELS, errorMessage } from './payment-labels'

const PER_PAGE = 20
const emptyFilters = () => ({
  q: '', type: '', status: '', from: '', to: '',
})

export default {
  name: 'PaymentSearchPage',
  components: {
    BAlert,
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    PaymentsTable,
  },
  data() {
    return {
      filters: emptyFilters(),
      rows: [],
      count: 0,
      page: 1,
      perPage: PER_PAGE,
      loading: false,
      errorText: '',
      typeOptions: [
        { value: '', text: 'Любой' },
        ...Object.entries(TYPE_LABELS).map(([value, text]) => ({ value, text })),
      ],
      statusOptions: [
        { value: '', text: 'Любой' },
        { value: 'pending', text: 'pending' },
        { value: 'waiting_for_capture', text: 'waiting_for_capture' },
        { value: 'succeeded', text: 'succeeded' },
        { value: 'canceled', text: 'canceled' },
      ],
    }
  },
  created() {
    // the latest payments are what one usually wants to see first
    this.fetch()
  },
  methods: {
    search() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.filters = emptyFilters()
      this.search()
    },
    changePage(page) {
      this.page = page
      this.fetch()
    },
    async fetch() {
      this.loading = true
      this.errorText = ''
      try {
        const { data } = await paymentAdminApi.search({
          ...this.filters,
          from: this.filters.from ? moment(this.filters.from).startOf('day').toISOString() : '',
          to: this.filters.to ? moment(this.filters.to).endOf('day').toISOString() : '',
          skipCount: (this.page - 1) * this.perPage,
          maxResultCount: this.perPage,
        })
        this.rows = data.rows || []
        this.count = data.count || 0
      } catch (e) {
        this.errorText = errorMessage(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
